module.exports = __webpack_public_path__ + "static/media/pu-home.9e6b6701.ogg";